import { Link } from "react-router-dom";
import "./index.scss";
import Marquee from "react-fast-marquee";

const SlideBannerSection = () => {
  return (
    <section className="slide-banner">
      <Link to="/application" className="text-decoration-none">
        <Marquee gradientWidth="0" speed="70">
          <p className="slide-text">
            APPLY NOW . APPLY NOW . APPLY NOW . APPLY NOW . APPLY NOW . APPLY
            NOW . APPLY NOW . APPLY NOW . APPLY NOW . APPLY NOW . APPLY NOW .
            APPLY NOW . APPLY NOW . APPLY NOW . APPLY NOW . APPLY NOW . APPLY
            NOW . APPLY NOW . APPLY NOW . APPLY NOW . APPLY NOW . APPLY NOW .
            APPLY NOW . APPLY NOW . APPLY NOW . APPLY NOW . APPLY NOW . APPLY
            NOW . APPLY NOW . APPLY NOW . APPLY NOW . APPLY NOW .&nbsp;
          </p>
        </Marquee>
      </Link>
    </section>
  );
};
export default SlideBannerSection;
